import { render, staticRenderFns } from "./editDriverTeamForm.vue?vue&type=template&id=53cef6eb"
import script from "./editDriverTeamForm.vue?vue&type=script&lang=js"
export * from "./editDriverTeamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports